module.exports = __webpack_public_path__ + "img/109.e679a711.jpg";